
  import { defineComponent, ref } from 'vue'
  import { mapActions } from 'vuex'
  import { notification } from 'ant-design-vue'

  import ThumbPerfil from '@/assets/components/ThumbPerfil.vue'
  import { AccountService } from '@/services/AccountService'
  import { TokenService } from '@/services/TokenService'

  import {
    ContainerOutlined
  } from '@ant-design/icons-vue'

  export enum EContractStatus {
    PENDING = 1,
    ACTIVED,
    CANCELED,
    BLOCKED
  }

  export default defineComponent({
    name: 'HomeInfo',
    emits: ['update-home-info'],
    components: {
      ThumbPerfil,
      ContainerOutlined
    },
    props: {
      isMobile: {
        type: Boolean
      },
      isHome: {
        type: Boolean
      },
      isActionAdminOrSysAdmin: {
        type: Boolean
      }
    },
    data: () => ({
      serviceAccount: ref<AccountService>(),
      accountId: ref<number>(0),
      accountName: ref<string>(''),
      accountMail: ref<string>(''),
      accountPlanName: ref<string>(''),
      accountType: ref<any>(''),
      envelopesConsummation: ref<number>(0),
      envelopesLimit: ref<number>(0),
      whatsappConsummation: ref<number>(0),
      whatsappLimit: ref<number>(0),
      isExceededLimitEnvelope: ref<boolean>(false),
      isBlockedAccount: ref<boolean>(false),
      expiredAt: ref<string>('')
    }),
    async mounted () {
      this.serviceAccount = AccountService.getInstance()

      const accountData = await this.serviceAccount.GetAccountData()

      this.checkAccountStatus(accountData)

      const userDataByToken = TokenService.getUserData()
      this.accountId = accountData.id
      this.accountName = accountData.name
      this.accountMail = userDataByToken.userEmail
      this.accountPlanName = accountData.planName
      this.accountType = accountData.type
      this.expiredAt = new Date(accountData.expiredAt).toLocaleDateString('pt-BR')

      const accountWhastapp = await this.serviceAccount.GetLimitWhatsappAccount(accountData.id)
      this.whatsappConsummation = accountWhastapp.whatsappConsummation
      this.whatsappLimit = accountWhastapp.whatsappLimit

      const accountEnvelopes = await this.serviceAccount.GetLimitEnvelopesAccount(accountData.id)
      this.envelopesLimit = accountEnvelopes.envelopesLimit
      this.envelopesConsummation = accountEnvelopes.envelopesConsummation

      if (this.envelopesConsummation === this.envelopesLimit) {
        this.isExceededLimitEnvelope = true
      }

      this.$emit('update-home-info', {
        envelopesConsummation: this.envelopesConsummation,
        envelopesLimit: this.envelopesLimit
      })
    },
    methods: {
      ...mapActions('sections', [
        'setIsBlockedAccount'
      ]),
      async changePlan () {
        const accountInfo: any = await this.serviceAccount?.GetAccountData()
        const dataForChangePlan = {
          reference: 1,
          id: accountInfo.id,
          name: accountInfo.name === null ? '' : accountInfo.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          cpfCnpj: accountInfo.cpfCnpj,
          domain: accountInfo.domain,
          phone: accountInfo.phone,
          address: accountInfo.address === null ? '' : accountInfo.address.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          addressNumber: accountInfo.addressNumber,
          zipCode: accountInfo.zipCode,
          city: accountInfo.city === null ? '' : accountInfo.city.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          state: accountInfo.state === null ? '' : accountInfo.state.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          district: accountInfo.district === null ? '' : accountInfo.district.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
          contact: accountInfo.contact,
          planName: accountInfo.planName.toUpperCase(),
          planId: accountInfo.planId,
          productToken: process.env.VUE_APP_ROOT_PRODUCT_TOKEN,
          productUrl: process.env.VUE_APP_ROOT_PRODUCT_URL,
          isPartner: accountInfo.isPartner,
          partnerId: accountInfo.partnerId
        }

        const dataForChangePlanEncode = btoa(JSON.stringify(dataForChangePlan))
        window.location.href = process.env.VUE_APP_ROOT_GATEWAY_URL + '/plans?data=' + dataForChangePlanEncode
      },
      async checkAccountStatus (accountData: any) {
        const status = accountData.contractStatus

        switch (status) {
          case EContractStatus.CANCELED:
          case EContractStatus.BLOCKED:
            this.setIsBlockedAccount(true)
            this.isBlockedAccount = true

            notification.warning({
              message: 'Conta bloqueada',
              description: 'Sua conta foi bloqueada. Entre em contato com o suporte ou regularize o pagamento para continuar utilizando nossos serviços.',
              duration: 20
            })
            break

          case EContractStatus.PENDING:
            this.setIsBlockedAccount(false)

            notification.info({
              message: 'Conta pendente',
              description: 'Sua conta está pendente. Algumas funcionalidades podem ser limitadas até a regularização.',
              duration: 10
            })
            break

          default:
            this.setIsBlockedAccount(false)
            break
        }
      }
    }
})
